import { Box } from '@factorialco/deprecated-design-system'
import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import ContractHistory from 'modules/contracts/components/ContractHistory'
import { Timeline } from 'modules/contracts/components/ContractHistory/Timeline'
import type EmployeeContract from 'modules/contracts/lib/EmployeeContract'

interface Props {
  employeeId: string
  open: boolean
  selectedContractVersion: ContractVersionPageContractVersionFragment
  employeeContracts: EmployeeContract[]
  setSelectedGraphqlContractVersion: (contractVersionId: string | undefined) => void
  toggleHistory: () => void
}

const History = ({
  employeeId,
  open,
  selectedContractVersion,
  employeeContracts,
  setSelectedGraphqlContractVersion,
  toggleHistory,
}: Props) => {
  const allJobCatalogNodeUuids = employeeContracts.flatMap((contract) =>
    contract
      .sortedVersions('desc')
      .map((version) => version.jobCatalogTreeNodeUuid)
      .filter(Boolean)
  )

  return (
    <Sidepanel
      title={i18n.t('contract_versions.header.history')}
      open={open}
      onClose={() => toggleHistory()}
      closeLabel={i18n.t('common.close')}
      width="wide"
    >
      {employeeContracts
        .slice()
        .reverse()
        .map((contract, index) => {
          const reversedIndex = employeeContracts.length - 1 - index
          const previousEmployeeContract = employeeContracts[reversedIndex + 1]

          return (
            <Box
              flexDirection="row"
              width="full"
              gap="s16"
              paddingX="s8"
              style={{ zIndex: '1' }}
              key={`${contract.formattedStartOn()}-${reversedIndex}`}
              paddingBottom={previousEmployeeContract ? 's48' : 's0'}
            >
              <Timeline isTerminated={contract.hasExpired()} />
              <Box flexGrow paddingTop="s16" width="full">
                <ContractHistory
                  employeeContract={contract}
                  jobCatalogNodeUuids={allJobCatalogNodeUuids}
                  selectedContractVersion={selectedContractVersion}
                  employeeId={employeeId}
                  setSelectedGraphqlContractVersion={setSelectedGraphqlContractVersion}
                />
              </Box>
            </Box>
          )
        })}
    </Sidepanel>
  )
}

export default History
